/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuditAction {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    RESTORE = 'RESTORE',
}
